export const constants = {
  BASE_URL: "",
};

export const pathNames = {
  auditLog: "Audit Log",
  configuration: "Configuration",
  settings: "Settings",
  tools: "Tools",
  AWSConfiguration: "AWS Configuration",
  EmailScheduleConfiguration: "Email Schedule Configuration",
  DataImportScheduler: "Data Import",
  administration: "Administration",
  directoryConfiguration: "Directory Configuration",
  smtpConfiguration: "SMTP Configuration",
  licenseConfiguration: "License Configuration",
  userManagement: "User Management",
  Devices: "Asset Onboarding",
  jiraRole: "Jira Configuration",
  onboardingtools: "Onboard Tools",
  Servers: "Servers",
  projects: "Projects",
  jiraconfiguration: "Jira Configuration",
  sassp: "SASSP",
  assetOnboarding: "Asset Onboarding",
  onboard: "Onboard",
  approval: "Approval",
  onboarding: "Onboard",
  scanManagement: "Scan Management",
  completed: "Completed",
  inProgress: "In Progress",
  pending: "Pending",
  usersession: "User Session",
  masterlist: "",
  rolemapping: "Role Mapping",
  loginPageConfiguration: "Login Page Configuration",
};

export const userRestrictedAccess = [
  "/configuration/administration/tools",
  "/configuration/administration/groups",
  "/configuration/administration/directoryConfig",
  "/configuration/administration/smtpConfig",
  "/configuration/administration/licenseConfig",
  "/configuration/administration/userManagement",
];
